import { render, staticRenderFns } from "./TablaProbabilidad.vue?vue&type=template&id=6f6bd21c&scoped=true&"
import script from "./TablaProbabilidad.vue?vue&type=script&lang=js&"
export * from "./TablaProbabilidad.vue?vue&type=script&lang=js&"
import style0 from "./TablaProbabilidad.vue?vue&type=style&index=0&id=6f6bd21c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6bd21c",
  null
  
)

export default component.exports